module.exports = __webpack_public_path__ + "static/media/face.4d308ca6.jpeg";